//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/NXObject.js";
let d=[[[0,"GridColor",1,0],[0,"GridIsNonUniform",1,0],[0,"GridOnTop",1,0],[0,"GridType",1,0],[0,"PolarShowMajorLines",1,0],[0,"RectangularShowMajorLines",1,0],[0,"ShowGrid",1,0],[0,"ShowLabels",1,0],[0,"SnapToGrid",1,0]],[[[],"GetRectangularUniformGridSize",{R_:{grid_size:''}},0,0],[["grid_size"],"SetRectangularUniformGridSize",{},1,0],[[],"GetRectangularNonuniformGridSize",{R_:{nonuniform_grid_size:''}},0,0],[["nonuniform_grid_size"],"SetRectangularNonuniformGridSize",{},1,0],[[],"GetPolarGridSize",{R_:{polar_grid_size:''}},0,0],[["polar_grid_size"],"SetPolarGridSize",{},1,0]],[]];
SPLM.Preferences.WorkPlane = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Preferences.WorkPlane";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.WorkPlane.GridSize = class{
    constructor(major_grid_spacing,minor_lines_per_major,snap_points_per_minor){
        this.major_grid_spacing=major_grid_spacing;this.minor_lines_per_major=minor_lines_per_major;this.snap_points_per_minor=snap_points_per_minor;}
    get MajorGridSpacing(){return this.major_grid_spacing}
    set MajorGridSpacing(val){this.major_grid_spacing = val}
    get MinorLinesPerMajor(){return this.minor_lines_per_major}
    set MinorLinesPerMajor(val){this.minor_lines_per_major = val}
    get SnapPointsPerMinor(){return this.snap_points_per_minor}
    set SnapPointsPerMinor(val){this.snap_points_per_minor = val}
};

SPLM.Preferences.WorkPlane.NonuniformGridSize = class{
    constructor(xc_grid_size,yc_grid_size){
        this.xc_grid_size=xc_grid_size;this.yc_grid_size=yc_grid_size;}
    get XcGridSize(){if(this.xc_grid_size === undefined) this.xc_grid_size = new SPLM.Preferences.WorkPlane.GridSize(); return this.xc_grid_size}
    set XcGridSize(val){this.xc_grid_size = val}
    get YcGridSize(){if(this.yc_grid_size === undefined) this.yc_grid_size = new SPLM.Preferences.WorkPlane.GridSize(); return this.yc_grid_size}
    set YcGridSize(val){this.yc_grid_size = val}
};

SPLM.Preferences.WorkPlane.PolarGridSize = class{
    constructor(radial_grid_size,angular_grid_size){
        this.radial_grid_size=radial_grid_size;this.angular_grid_size=angular_grid_size;}
    get RadialGridSize(){if(this.radial_grid_size === undefined) this.radial_grid_size = new SPLM.Preferences.WorkPlane.GridSize(); return this.radial_grid_size}
    set RadialGridSize(val){this.radial_grid_size = val}
    get AngularGridSize(){if(this.angular_grid_size === undefined) this.angular_grid_size = new SPLM.Preferences.WorkPlane.GridSize(); return this.angular_grid_size}
    set AngularGridSize(val){this.angular_grid_size = val}
};

SPLM.Preferences.WorkPlane.Grid = Object.freeze({
    "Polar" : "Polar", "Rectangular" : "Rectangular"});

export default SPLM;